import noTrucksAdded from "@/assets/add-rmpm-truck.svg"
import RoundedButton from "@/components/rounded-button"
import { Icon } from "@/icons/icon"
import { cn } from "@/lib/utils"
import { TruckType } from "@/store/rmpm"

export interface NoTrucksAddedProps {
  className?: string
  truckType: TruckType
  onClickAdd?: () => void
  isHandover?: boolean
}

export default function NoTrucksAdded({
  className,
  truckType,
  onClickAdd,
  isHandover = false
}: NoTrucksAddedProps) {
  function truck() {
    if (truckType === "rm") {
      return "RM"
    }

    return "PM"
  }

  return (
    <div className={cn("flex flex-col items-center", className)}>
      <img className="h-25 w-auto" src={noTrucksAdded} alt="Add trucks" />
      {isHandover ? (
        <div className="mt-8 text-center">
          <h2 className="font-semibold text-xl">No trucks available!</h2>
          <p className="text-label-text text-base font-normal mt-4">
            There are no working trucks in {truck()} for handover.
          </p>
        </div>
      ) : (
        <>
          <div className="mt-8 text-center">
            <h2 className="font-semibold text-xl">No trucks added!</h2>
            <p className="text-label-text text-base font-normal mt-4">
              There are no working trucks in {truck()}. Please add a truck to get
              started.
            </p>
          </div>

          <RoundedButton
            icon={<Icon name="Plus" />}
            className="mt-10"
            onClick={onClickAdd}
          >
            Add Truck
          </RoundedButton>
        </>

      )}
    </div>
  )
}
